<template>
    <Modal
        width="90%"
        height="800"
        v-model.trim="modal"
        title="打卡详情"
    >
      <div
      class="flexBox"
      >
        <div class="flex2">
            <div>出勤记录</div>
            <c-list
                :data="cqList"
                :columns="cqColumns"
                :showPage="false"
            >
            </c-list>
        </div>
        <div class="flex">
            <div>接送记录</div>
            <c-list
                :data="jsList"
                :columns="jsColumns"
                :showPage="false"
            >
            </c-list>
        </div>
      </div>
    </Modal>
  </template>
  
  <script>
  import { Component, Vue } from "vue-property-decorator";
  import { mapState } from "vuex";
  import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
  import ListMixin from "view-ui-admin/src/mixins/list";
    import FormMixin from "view-ui-admin/src/mixins/form";

  
  const module = "df";
    const initWhere = {
    status: {
        $eq: ""
    },
    title: {
        $like: ""
    }
    };
  @Component({
    mixins: [RouteParamsMixin]
  })
  export default class extends Vue {
    data() {
      return {
        modal: false,
        detail: null,
        cqList:[],
        cqColumns: [
            {
              title: "学生",
              render: (h, { row }) =>
                h("span", null, `${row?.student?.name}`)
            },
            {
              title: "状态",
              render: (h, { row }) =>
                [
                  h("span", null, `${this.dicts["CourseSignInType"].find(i => i['value'] == row['type'])?.label || "未知"}`),
                  row['tk'] && ("[调课: " + row['tk']?.['tkname'] + "]"),
                  row['deduct'] && "(已扣课时)",
              ]
            },
            {
              title: "原因",
              render: (h, { row }) =>
                h("span", null, `${row?.reason}`)
            },
  
            {
              title: "操作",
              key: "action",
              width: 200,
              render: (h, { row }) =>
                [
                 row['deduct'] && h("c-confirm-button", {
                  props: {
                    buttonText: "恢复课时",
                    confirmText: "确认恢复课时？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row);
                    }
                  }
                })
                ]
            }
        ],
        jsList:[],
        jsColumns: [
            {
              title: "学生",
              render: (h, { row }) =>
                h("span", null, `${row?.student?.name}`)
            },
            {
              title: "关系",
              render: (h, { row }) =>
                h("span", null, `${this.dicts["CourseBringRelation"].find(i => i['value'] == row['relation'])?.label || "未知"}`)
            },
            {
              title: "姓名",
              render: (h, { row }) =>
                h("span", null, `${row?.familyName}`)
            },
        ],
      };
    }
    show(detail) {
        this.modal = true;
        this.jsList = detail["brings"];
        this.cqList = detail["signIns"];
        this.detail = detail;
    }
    async confirmDelete({ student }) {
      await this.$store.dispatch("courses/postAction", {
        action: "recoryGs",
        body: { courseId: this.detail.id, studentId: student?.id, classId: this.detail.classId }
      });
        this.modal = false;
        this.$emit("get-list", null);
        this.$Message.success("修改状态成功");
    }
  
  }
  </script>
<style scoped>
.flexBox {
    display: flex;
}
.flex {
    flex: 1;
}
.flex2{
    flex: 2;
}
</style>
  